import { FC } from "react";
import appStyles from "../../../App.module.css";
import BackArrow from "../../../amt/components/icons/BackArrow";

interface PrevButtonProps {
  disabled?: boolean;
  onClick: () => void;
}

const PrevButton: FC<PrevButtonProps> = (props: PrevButtonProps) => {
  return (
    <button
      className={`${appStyles.bfButton} ${appStyles.bfButtonSecondary} ${appStyles.bfButtonOutline} ${appStyles.bfbuttonHasIcon} ${appStyles.bfbuttonIconBefore}`}
      type="button"
      onClick={props.onClick}
    >
      Back
      <span className={`${appStyles.bfButtonIcon}`}>
        <BackArrow />
      </span>
    </button>
  );
};

export default PrevButton;
